import React, { useRef, useEffect } from "react";
import Lottie from "lottie-react";
import logoLottie from "../lottie/logo.json";
import * as styles from "./header.module.scss";

function Mobilelogo({ isHide }) {
  const lottieRef = useRef(null);

  useEffect(() => {
    if (!isHide) {
      lottieRef.current.setSpeed(1.5);
      lottieRef.current.goToAndPlay(1);
    } else return;
  }, [isHide]);

  return (
    <Lottie
      autoplay={true}
      animationData={logoLottie}
      lottieRef={lottieRef}
      className={styles.animation}
      loop={false}
    />
  );
}

export default Mobilelogo;
